export const ColorTheme = {
  primaryColor: '#1aa7e8',
  primaryColorLight: '#007e9b',
  primaryColorDark: '#003c58',
  backgroundColor: '#eef2f7',
  font: {

  },
  formControls: {
    borderColor: '#dad8d8'
  }
};

export const CONTROL_FIELD_HEIGHT = 40;
export const CONTROL_FIELD_BORDER_COLOR = '#7f91a866';


export {};